export function parseCreatedTicketId(data: unknown): string | undefined {
  if (data == null) {
    return undefined;
  }
  if (typeof data === 'string') {
    const trimmed = data.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  if (typeof data === 'number' && !Number.isNaN(data)) {
    return String(data);
  }
  if (typeof data !== 'object' || Array.isArray(data)) {
    return undefined;
  }
  const record = data as Record<string, unknown>;
  const raw = record.ticketId ?? record.TicketId ?? record.id ?? record.Id;
  if (typeof raw === 'string' && raw.trim().length > 0) {
    return raw.trim();
  }
  if (typeof raw === 'number' && !Number.isNaN(raw)) {
    return String(raw);
  }
  return undefined;
}

/**
 * When POST /tickets returns 201 with an empty body, ASP.NET often still sends Location for the new resource.
 * Matches .../tickets/{ticketId}/details (and similar) or .../tickets/{ticketId}.
 */
export function parseCreatedTicketIdFromLocationHeader(
  location: string | undefined
): string | undefined {
  if (!location || typeof location !== 'string') {
    return undefined;
  }
  const trimmed = location.trim();
  if (!trimmed) {
    return undefined;
  }
  try {
    const pathOnly = trimmed.includes('://') ? new URL(trimmed).pathname : trimmed;
    const withSubresource =
      pathOnly.match(/\/tickets\/([^/]+)\/(?:details|attachments|messages)/i)?.[1] ??
      pathOnly.match(/\/tickets\/([^/?#]+)\/?$/i)?.[1];
    const id = withSubresource?.trim();
    return id && id.length > 0 ? id : undefined;
  } catch {
    return undefined;
  }
}
